import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ResultsContainer = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(3)} ${theme.spacing(5)}`};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: block;
  padding: ${({ theme }) =>
    `${theme.spacing(4)} ${theme.spacing(3)} ${theme.spacing(0.5)}`};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const List = styled.ul`
  margin: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(1)}`};

  list-style: none;
`;

export const ListItem = styled.li``;

export const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${({ theme }) => theme.spacing(2)};

  width: 100%;
  height: 100%;

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;
